import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import { ICreatePalletsRequest, ICreatePalletsResponse } from "model";
import { IErrorResponse } from "model/Common/IErrorResponse";
import { call, put, takeEvery } from "redux-saga/effects";
import { PalletActions } from "redux/actions";
import { PalletApiService } from "services";
import xlsx, { IJsonSheet } from "json-as-xlsx";
let settings = {
  fileName: "New_Pallet", // Name of the resulting spreadsheet
};
function* createPallets(action: PayloadAction<ICreatePalletsRequest>) {
  try {
    const result: ICreatePalletsResponse = yield call(
      PalletApiService.createPallets,
      action.payload
    );
    if (result.succeeded) {
      yield put(PalletActions.createPallets.success(result.data!));
      AlertHelper.showAlert("Create Pallet Successfully", EAlertType.SUCCESS);

      if (action.payload.exportPallet) {
        let data: IJsonSheet[] = [
          {
            sheet: "NewPallet",
            columns: [
              { label: "STT", value: "stt" }, // Top level data
              { label: "Pallet Code", value: "palletCode" }, // Custom format
              {
                label: "Pallet Type",
                value: "palletType",
              }, // Run functions
            ],
            content:
              result.data?.map((e, i) => {
                return {
                  stt: i + 1,
                  palletCode: e.palletCode,
                  palletType: e.palletType,
                };
              }) || [],
          },
        ];
        xlsx(data, settings);
      }
    } else {
      const error = result as IErrorResponse;
      yield put(PalletActions.createPallets.failed(error));
    }
  } catch (error) {
    yield put(PalletActions.createPallets.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(PalletActions.createPallets.request, createPallets);
}
